<template>
  <v-container fill-height fluid grid-list-lg class="py-2 px-3">
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn color="secondary" @click="history = !history">История покупок</v-btn> 
      </v-flex>
      <v-navigation-drawer v-model="history" fixed right style="margin-top:96px; padding-bottom: 96px;">
        <v-layout row wrap>
          <v-flex xs12 v-if='buyHistory.length === 0'>
            <v-card>
              <v-card-title primary-title>
                История покупок пуста
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex xs12 v-else v-for='(order, index) in buyHistory' :key="index">
            <v-card>
              <v-card-title flex justify-center>
                <h3>{{ order.rate.name }}</h3>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>Приобретено :</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ getDateFromString(order.start_date) }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>Окончание :</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ getDateFromString(order.end_date) }}</v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <v-btn v-if="order.payment.autopay" flat color="deep-purple accent-4" small style="margin-left: 20px;" @click="disablePayment(order)">Отключить автопродление</v-btn>
              </v-card-text>
              <v-card-actions class="flex justify-center">
                <p v-if="order.state === 'e'" class="success-status green--text">Активно</p>
                <p v-if="order.state === 'd'" class="success-status red--text">Истекло</p>
                <v-btn color="primary" style="margin-left: 20px;" @click="getPaymentLinkHistory(order)">Продлить</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-navigation-drawer>
      <ServiceItem  v-for='service in services' :service='service' :key='service.id'/>
    </v-layout>
  </v-container>
</template>

<script>
  import ServiceItem from '../Payment/ServiceItem'
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Payment',
    components: {
      ServiceItem,
    },
    created () {
      this.$store.dispatch('app/account/getRates').then(response => this.services = response )
      this.$store.dispatch('app/account/getHistory').then(response => this.buyHistory = response)
    },
    data() {
      return {
        services: [],
        buyHistory: [],
        history: false
      }
    },
    computed: {
      ...mapGetters('app/account', ['accountEmail', 'accountPhone', 'getCompanies'])
    },
    methods: {
      getDateFromString(val) {
        return moment(val, 'YYYY-MM-DD').format('DD.MM.YYYY')
      },
      getPaymentLinkHistory(item) {
        const order = {
          rate_id: item.rate.id,
          autopay: true
        }
        if (this.accountEmail ) {
          order['email'] = this.accountEmail
        } else {
          order['phone'] = this.accountPhone
        }
        this.$store.dispatch('app/account/paymentInit', order).then(response => window.location.replace(response.payment_url))
      },
      disablePayment(val) {
        this.$store.dispatch('app/account/paymentDisable', val.payment.id).then(response =>
          this.$dmsSuccessNoty('Автоплатеж успешно отменён')
        )
        val.payment.autopay = false
      }
    },
  }
</script>

<style lang="scss">
.payment__title {
  margin-top: 60px;
}

.history__title {
  margin-top: 20px;
  margin-bottom: 16px;
}

.payment__price {
  font-size: 30px;
  line-height: 36px;
  font-weight: 600;
  margin: 20px 0;
  margin-top: auto;
}

.payment__card {
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & p {
    text-align: center;
  }

  &.payment__card--disk {
    min-height: 100px;
  }
}

.success-status {
  text-transform: uppercase;
  font-weight: bolder;
}

.hidden-element {
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/apps/account/components/Account/Payment.vue